<template>
  <div class="hrt-component">
    <!-- Icon - Using direct shield SVG as requested -->
    <img 
      src="/img/hrt-shield.svg" 
      alt="OnePass Authentication" 
      class="hrt-icon" 
    />

    <!-- Landing Text -->
    <div class="hrt-content" v-html="renderedLandingText" />

    <!-- Info Section -->
    <div class="hrt-info">
      <div class="info-row">
        <span class="info-label">When</span>
        <span class="info-value">{{ formatDate(authInfo.createdDate) }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Device</span>
        <span class="info-value">{{
          formatPlatform(authInfo.sourcePlatform)
        }}</span>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-4">
      <button @click="$emit('deny')" class="hrt-button !bg-[#3A3A3A]">
        <i class="fa fa-close">&nbsp;</i>
        NO, DON'T ALLOW
      </button>
      <button @click="$emit('confirm')" class="hrt-button">
        <i class="fa fa-check">&nbsp;</i>
        YES, IT'S ME
      </button>
    </div>

    <!-- Footer Text -->
    <div class="hrt-disclaimer" v-html="renderedFooterText" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import MarkdownIt from "markdown-it";
import type { IconType } from "./types";

interface AuthInfo {
  id: number;
  createdDate: string;
  email: string;
  customerId: number;
  transactionType: string;
  authType: string;
  authValidity: string;
  initiatedBy: string;
  sourcePlatform: string;
  emailSentAt: string;
  authStatus: string;
  resendTimer: number;
  requestFrom: string;
}

const props = defineProps<{
  icon: IconType;
  textLanding: string;
  textFooter: string;
  authInfo: AuthInfo;
}>();

defineEmits<{
  (e: "confirm"): void;
  (e: "deny"): void;
}>();

const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
});

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const formatPlatform = (platform: string) => {
  return platform === "WEB" ? "Browser" : platform;
};

const renderedLandingText = computed(() => {
  return md.render(props.textLanding);
});

const renderedFooterText = computed(() => {
  return md.render(props.textFooter);
});
</script>

<style lang="scss" scoped>
@use "./styles/hrt.scss";
</style>
